export default [
  {
    name: 'organisation',
    label: 'organisation',
    dictionary: 'organization',
    type: 'select',
    itemValue: 'id',
    itemText: 'shortName',
    default: {},
  },
  {
    name: 'serial',
    label: 'serial',
    dictionary: 'devicestatuses',
    type: 'select',
    itemValue: 'serial',
    itemText: 'serial',
    default: {},
  },
  {
    name: 'article',
    label: 'article',
    dictionary: 'goods',
    type: 'select',
    itemValue: 'articleNumber',
    itemText: 'articleNumber',
    default: {},
  },
]
